import { render, staticRenderFns } from "./HmBrandSelector.vue?vue&type=template&id=45858234&scoped=true&"
import script from "./HmBrandSelector.vue?vue&type=script&lang=js&"
export * from "./HmBrandSelector.vue?vue&type=script&lang=js&"
import style0 from "./HmBrandSelector.vue?vue&type=style&index=0&id=45858234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45858234",
  null
  
)

component.options.__file = "HmBrandSelector.vue"
export default component.exports